
import { isLoadingEndpoint } from 'mega-composable'
import { computed, defineComponent } from 'vue'
import { tasks } from '@/store/case'
import { isEmpty } from 'lodash-es'

export default defineComponent({
  setup() {
    const isLoading = isLoadingEndpoint('request/tasks')

    const prevoiusTasks = computed(() => tasks.value?.previous)
    const hasPreviousTasks = computed(() => !isEmpty(prevoiusTasks.value))

    return {
      isLoading,
      prevoiusTasks,
      hasPreviousTasks
    }
  }
})

